import { store } from "@/store";
import { getFailedUploadItemTextFromFailedList as GetFailedUploadFormFields } from "@/_helpers/utility.js";

export default {
    install(Vue) {
        Vue.prototype.$submitFormMessage = {
            NextStepSubmitMessagePopup: (payload) => store.dispatch("submitFormMessage/NextStep", payload),

            ShowProgressWithUploadPopup: (payload) =>
                store.dispatch("submitFormMessage/ShowProgressWithUpload", payload),

            UpdateUploadProgressPopup: () => {
                if (store.state.fileUpload.totalNoOfUploadedFile == 0) return;

                store.dispatch("submitFormMessage/UpdateUploadProgress", {
                    noOfUploadedFile: store.state.fileUpload.noOfUploadedFile,
                });
            },

            ShowProgressWithoutUploadPopup: (payload) =>
                store.dispatch("submitFormMessage/ShowProgressWithoutUpload", payload),

            FinishUploadPopup: (payload) => store.dispatch("submitFormMessage/FinishUpload", payload),

            ShowResultPopup: (payload) => store.dispatch("submitFormMessage/ShowResult", payload),

            ShowMesaagePopup: ({ title = "", message = "" }) =>
                store.dispatch("submitFormMessage/ShowResultMessage", {
                    header: title,
                    result: {
                        message: message,
                        failedItems: [], // Only show message or title, no need to show failed items
                    },
                }),

            HideMessagePopup: () => store.dispatch("submitFormMessage/HideMessageModal"),

            FileUploadHandleWithPopup: async ({
                isSubmit,
                pendingFiles,
                commands,
                getFailedText,
                uploadFinishCallback,
            }) => {
                if (pendingFiles.length === 0) {
                    store.dispatch("submitFormMessage/ShowProgressWithoutUpload", { isSubmit }); // this.ShowProgressWithoutUploadPopup
                    return { status: "AllSuccess", successfulList: [], failedList: [], commands };
                }

                // this.ShowProgressWithUploadPopup
                store.dispatch("submitFormMessage/ShowProgressWithUpload", {
                    total: pendingFiles.length,
                    isSubmit,
                });

                // this.UpdateUploadProgressPopup
                const updateUploadProgress = () => {
                    if (store.state.fileUpload.totalNoOfUploadedFile == 0) return;

                    store.dispatch("submitFormMessage/UpdateUploadProgress", {
                        noOfUploadedFile: store.state.fileUpload.noOfUploadedFile,
                    });
                };

                const res = await store.dispatch("fileUpload/addPendingFilesAndUpload", {
                    pendingFiles,
                    updateUploadProgress,
                });

                const failedFilesFields = GetFailedUploadFormFields(res.failedList, getFailedText);
                uploadFinishCallback(failedFilesFields);

                return {
                    ...res,
                    commands,
                };
            },
        };
    },
};
